import React, { Suspense } from "react";
import Routes from "./routes";
import './App.scss';
import {
  HashRouter as Router
} from "react-router-dom";
import { ToastContainer } from "react-toastify";

const App = () => {

  return (
    <Suspense fallback="loading">  <Router>
      <ToastContainer />
      <Routes />
    </Router>
    </Suspense>
  );
};

export default App;
